module.exports = __webpack_public_path__ + "img/bvi_4.6eb20d3d.png";